import { CrudActions, TradingEntityMeta } from 'api'

export const createTradingEntityUpdateMetaAction = (tradingEntityMeta: TradingEntityMeta) => {
  if (
    tradingEntityMeta.primaryCoverUserId ||
    tradingEntityMeta.secondaryCoverUserId ||
    tradingEntityMeta.aliasTypeAndValues?.length ||
    tradingEntityMeta.primeBrokerId
  ) {
    return CrudActions.tradingEntityMetaUpsert(tradingEntityMeta)
  }
  return CrudActions.tradingEntityMetaDelete(tradingEntityMeta.id)
}
